import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import AOS from 'aos';
import { UtilService } from 'src/app/shared/services/util.service';
import { WebserviceService } from 'src/app/shared/services/webservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-presentation19',
  templateUrl: './presentation19.component.html',
  styleUrls: ['./presentation19.component.scss'],
})
export class Presentation19Component implements OnInit {
  cloudFrontUrl = environment.cloudFrontUrl;
  myLinksS3URL = environment.myLinksS3URL;
  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    autoplay: true,
    prevArrow:
      "<i class='fas fa-circle' style='position: absolute; bottom: -20px; opacity: .5; color: #fff; text-align: center; left: 0; right: 30px;'></i>",
    nextArrow:
      "<i class='fas fa-circle' style='position: absolute; bottom: -20px; opacity: .5; color: #fff; text-align: center; left:30px; right: 0;'></i>",
  };
  slickInit(e: any) {
    console.log('slick initialized');
  }
  referralId!: string;
  userName!: string;
  userDetails: any = {};
  pwdToggle = false;

  countriesList: any[] = [];
  registerForm!: FormGroup;
  city!: string;
  country!: string;

  constructor(
    private _service: WebserviceService,
    private aRoute: ActivatedRoute,
    private utilService: UtilService,
    private router: Router
  ) {
    [
      this.userDetails,
      this.userName,
      this.country,
      this.city,
      this.countriesList,
      this.referralId,
    ] = [...this.utilService.getUserDetaisForMyLinksSection(this.aRoute)];
  }

  gotoRegistration() {
    this.router.navigate([], {
      fragment: 'reg_form',
      queryParamsHandling: 'merge',
    });
  }

  ngOnInit(): void {
    AOS.init();
    this.registerForm = this.utilService.getRegisterForm();
  }

  get f() {
    return this.registerForm.controls;
  }

  submitRegister() {
    this._service.doRegistrationForPresentationLinks(
      this.registerForm,
      this.userDetails.userId,
      this.referralId
    );
  }
}
